import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import Modal from '@material-ui/core/Modal';
import DataReactTable from '../../MedicalOrders/DataReactTable';
import ReactTableActionsMedics from '../../MedicalOrders/ReacTableActionsMedics';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import ReactTableActionsDiagnostic from '../../Diagnostic/ReactTableActionsDiagnostic';
import moment from 'moment';
import renderRadioButtonField from '../../../../../../shared/components/form/RadioButton';

const renderField = ({
    input, placeholder, type, meta: { touched, error },
}) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
        <input {...input} placeholder={placeholder} type={type} />
        {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
);

renderField.propTypes = {
    input: PropTypes.shape().isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
};

renderField.defaultProps = {
    placeholder: '',
    meta: null,
    type: 'text',
};

class SectionAilment extends Component {
    constructor() {
        super();
        this.state = {
            sectionAilment: {},
            showCommentaties: [],
            showDate: [],
            commentaries: [],
            openMedicaments: false,
            loadMedicaments: true,
            medicament: [],
            dataMedicaments: [],
            openModal: false,
            load: true,
            dataDiagnostic: [],
            diagnostic: [],
            tableData: [],
            showTable: false

        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.sectionAilment !== this.props.sectionAilment) {
            return {
                sectionAilment: this.props.sectionAilment
            }
        }
    }

    componentDidMount() {
        this.setState({ showCommentaties: new Array(this.props.sectionAilment[this.props.section].length), commentaries: new Array(this.props.sectionAilment[this.props.section].length) })
    }

    render() {

        const reactTableMedicaments = {
            tableHeaderData: [{
                Header: 'Principio activo',
                accessor: 'principioactivo',
                disableGlobalFilter: true,
                width: 65,
            },
            {
                Header: 'Producto',
                accessor: 'producto',
            },
            {
                Header: 'Forma Farmacéutica',
                accessor: 'formafarmaceutica',
            },
            {
                Header: 'Codigo',
                accessor: 'atc',
            },
            ],
            tableRowsData: this.state.dataMedicaments
        };

        const reactTableFoundDiagnostics = {
            tableHeaderData: [{
                Header: 'Codigo',
                accessor: 'codigo',
                disableGlobalFilter: true,
                width: 65,
            },
            {
                Header: 'Nombre',
                accessor: 'nombre',
            },
            ],
            tableRowsData: this.state.dataDiagnostic
        };

        const row = {};

        return (
            <div className="form" style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", width: '100%', marginTop: 20 }}>
                    <div style={{ width: '50%' }}>
                        {this.props.sectionAilment[this.props.section].map((ailment, index) => {
                            if (index % 2 !== 1) {
                                return (<Fragment>
                                    <div key={index} style={{ display: 'flex', height: 70 }}>
                                        <div style={{ width: 350 }}>
                                            <span className="form__form-group-label">{ailment.ailment}</span>
                                            <div className="form__form-group-field">
                                               
                                            <label
                                                    className="radio-btn"
                                                >
                                                    <input
                                                        className="radio-btn__radio"
                                                        name={ailment.ailment+ "-"+this.props.section}
                                                        type="radio"
                                                        value={'Si'}
                                                        checked={ailment.value === "Si"}
                                                        onChange={(e) => {
                                                            this.props.handlerAilment(e.target.value, this.props.section, this.props.sectionIndex, index);
                                                            var showCommentaties = this.state.showCommentaties;
                                                            showCommentaties[index] = true;
                                                            this.setState({ showCommentaties: showCommentaties });
                                                        }}
                                                    />
                                                    <span className="radio-btn__radio-custom" />
                                                    <span className="radio-btn__label">{"Sí"}</span>
                                                </label>
                                                <label
                                                    className="radio-btn"
                                                >
                                                    <input
                                                        className="radio-btn__radio"
                                                        name={ailment.ailment+ "-"+this.props.section}
                                                        type="radio"
                                                        value={'No'}
                                                        checked={ailment.value === "No"}
                                                        onChange={(e) => {
                                                            this.props.handlerAilment(e.target.value, this.props.section, this.props.sectionIndex, index);
                                                            var showCommentaties = this.state.showCommentaties;
                                                            showCommentaties[index] = false;
                                                            this.setState({ showCommentaties: showCommentaties });
                                                        }}
                                                    />
                                                    <span className="radio-btn__radio-custom" />
                                                    <span className="radio-btn__label">{"No"}</span>
                                                </label>
                                            </div>
                                        </div>
                                        {this.props.sectionIndex === 1 || this.props.sectionIndex === 2 || this.props.sectionIndex === 3
                                            || this.props.sectionIndex === 4 || this.props.sectionIndex === 6 ? null :
                                            <div className="form__form-group" style={{ width: '90%', marginRight: 10, marginTop: 20 }}>
                                                <div className="form__form-group-field">
                                                    <input
                                                        key={`comment-${ailment.ailment}`}
                                                        name={`comment-${ailment.ailment}`}

                                                        disabled={ailment.value !== "Si"}
                                                        type="text"
                                                        placeholder="NO REFIERE."
                                                        value={ailment.commentary}
                                                        onChange={(e) => {
                                                            this.props.handlerCommentary(e.target.value, this.props.section, this.props.sectionIndex, index);
                                                            var commentaries = this.state.commentaries;
                                                            commentaries[index] = e.target.value;
                                                            this.setState({ commentaries: commentaries });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        }
                                        {this.props.sectionIndex === 0 ?
                                            <div className="form__form-group-field" style={{ marginLeft: 10, }}>
                                                <MuiPickersUtilsProvider utils={MomentUtils} >
                                                    <DatePicker
                                                        className="material-form__field"
                                                        disabled={ailment.value !== "Si"}
                                                        style={{ width: '50%' }}
                                                        value={ailment.date}
                                                        onChange={(date) => {
                                                            this.props.handlerAilmentDate(moment(new Date(date)).format("YYYY/MM/DD"), this.props.section, this.props.sectionIndex, index);
                                                            var showDate = this.state.showDate;
                                                            showDate[index] = true;
                                                            this.setState({ showDate: showDate });
                                                        }}
                                                        animateYearScrolling
                                                        format="yyyy/MM/D"
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </div>
                                            : null}
                                    </div>
                                    {this.props.sectionIndex === 6 && ailment.value === "Si" ?
                                        <table className="table table--bordered" >
                                            <thead>
                                                <tr>
                                                    <td >Vacuna </td>
                                                    <td >Ultima Dosis </td>
                                                    <td ></td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><TextField
                                                        type="text"
                                                        className="material-form__field"
                                                        style={{ width: 350 }}
                                                        onChange={(e) => {
                                                            row.vacuna = e.target.value;
                                                        }}
                                                    />
                                                    </td>
                                                    <td> <MuiPickersUtilsProvider utils={MomentUtils} >
                                                        <DatePicker
                                                            autoOk
                                                            className="material-form__field"
                                                            format="yyyy/MM/DD"
                                                            animateYearScrolling
                                                            style={{ width: 180 }}
                                                            onChange={(date) => {
                                                                row.fecha = moment(new Date(date)).format('YYYY-MM-DD');
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider></td>
                                                    <td><Button color="primary" onClick={() => {
                                                        if (Object.keys(row).length !== 0) {

                                                            this.setState(prevState => ({
                                                                tableData: [...prevState.tableData, row]
                                                            }));
                                                            this.setState({ showTable: true }, () => {
                                                                this.props.handlerAlimentTable(this.state.tableData, this.props.section, this.props.sectionIndex, index);
                                                            });

                                                        } else {
                                                            alert("No ha ingresado los valores");
                                                        }
                                                    }}>
                                                        <span className="lnr lnr-plus-circle" style={{ margin: 'auto', fontSize: 20 }} />
                                                    </Button></td>
                                                </tr>
                                                {this.state.showTable ?
                                                    this.state.tableData.map((data, num) => {
                                                        return <tr key={num}>
                                                            <td>{data.vacuna}</td>
                                                            <td>{data.fecha}</td>
                                                            <td><Button color="primary" onClick={() => {
                                                                this.setState({ showTable: false });
                                                                this.state.tableData.splice(num, 1);
                                                                this.setState({ showTable: true }, () => {
                                                                    this.props.handlerAlimentTable(this.state.tableData, this.props.section, this.props.sectionIndex, index);
                                                                });
                                                            }}>
                                                                <span className="lnr lnr-trash" style={{ margin: 'auto', fontSize: 20 }} />
                                                            </Button>
                                                            </td>
                                                        </tr>
                                                    })
                                                    : null}
                                            </tbody>
                                        </table>
                                        : null}
                                    {this.props.sectionIndex === 1 && ailment.value === "Si" ?
                                        <table className="table table--bordered" >
                                            <thead>
                                                <tr>
                                                    <td>Tipo </td>
                                                    <td >Nombre </td>
                                                    <td >Fecha </td>
                                                    <td >Motivo de procedimiento </td>
                                                    <td ></td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><TextField
                                                        className="material-form__field"
                                                        style={{ width: 200, marginTop: 12 }}
                                                        select
                                                        onChange={(event) => {
                                                            row.tipo = event.target.value;
                                                        }}
                                                    >
                                                        <MenuItem className="material-form__option" key={0} value={'Quirurgico'}>Quirurgico</MenuItem>
                                                        <MenuItem className="material-form__option" key={1} value={'No Quirurgico'}>No Quirurgico</MenuItem>
                                                    </TextField> </td>
                                                    <td><TextField
                                                        type="text"
                                                        className="material-form__field"
                                                        style={{ width: 350 }}
                                                        onChange={(e) => {
                                                            row.nombre = e.target.value;
                                                        }}
                                                    />
                                                    </td>
                                                    <td> <MuiPickersUtilsProvider utils={MomentUtils} >
                                                        <DatePicker
                                                            format="yyyy/MM/DD"
                                                            animateYearScrolling
                                                            style={{ width: 180 }}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            onChange={(date) => {
                                                                row.fecha = moment(new Date(date)).format('YYYY-MM-DD');
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider></td>
                                                    <td > <TextField
                                                        type="text"
                                                        className="material-form__field"
                                                        style={{ width: 350 }}
                                                        onChange={(e) => {
                                                            row.motivo = e.target.value;
                                                        }}
                                                    />
                                                    </td>
                                                    <td><Button color="primary" onClick={() => {
                                                        if (Object.keys(row).length !== 0) {

                                                            this.setState(prevState => ({
                                                                tableData: [...prevState.tableData, row]
                                                            }));

                                                            this.setState({ showTable: true }, () => {
                                                                this.props.handlerAlimentTable(this.state.tableData, this.props.section, this.props.sectionIndex, index);
                                                            });
                                                        } else {
                                                            alert("No ha ingresado los valores");
                                                        }
                                                    }}>
                                                        <span className="lnr lnr-plus-circle" style={{ margin: 'auto', fontSize: 20 }} />
                                                    </Button></td>
                                                </tr>
                                                {this.state.showTable ?
                                                    this.state.tableData.map((data, num) => {
                                                        return <tr key={num}>
                                                            <td>{data.tipo}</td>
                                                            <td>{data.nombre}</td>
                                                            <td>{data.fecha}</td>
                                                            <td>{data.motivo}</td>
                                                            <td><Button color="primary" onClick={() => {
                                                                this.setState({ showTable: false });
                                                                this.state.tableData.splice(num, 1);
                                                                this.setState({ showTable: true }, () => {
                                                                    this.props.handlerAlimentTable(this.state.tableData, this.props.section, this.props.sectionIndex, index);
                                                                });

                                                            }}>
                                                                <span className="lnr lnr-trash" style={{ margin: 'auto', fontSize: 20 }} />
                                                            </Button>
                                                            </td>
                                                        </tr>
                                                    })
                                                    : null}
                                            </tbody>
                                        </table>
                                        : null}
                                    {this.props.sectionIndex === 2 && ailment.value === "Si" ?
                                        <table className="table table--bordered" >
                                            <thead>
                                                <tr>
                                                    <td>Buscar </td>
                                                    <td >Principio Activo - Denominación Común Internacional </td>
                                                    <td >Concentración </td>
                                                    <td >Vía de Administración </td>
                                                    <td >Dosis </td>
                                                    <td >Frecuencia </td>
                                                    <td >Fecha Inicio </td>
                                                    <td >Fecha Fin </td>
                                                    <td ></td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><Button
                                                        color="primary"
                                                        style={{ paddingLeft: 10, margin: 'auto', fontSize: 20 }}
                                                        onClick={() => {

                                                            this.setState({ openMedicaments: true });
                                                        }}
                                                    >
                                                        <span className="lnr lnr-magnifier" style={{ fontSize: 20 }} />
                                                    </Button> </td>
                                                    <td ><TextField
                                                        type="text"
                                                        className="material-form__field"
                                                        disabled
                                                        style={{ width: 350 }}
                                                        value={typeof this.state.medicament.principioactivo !== 'undefined' ? this.state.medicament.principioactivo : ""}
                                                    /> </td>
                                                    <td ><TextField
                                                        type="text"
                                                        className="material-form__field"
                                                        disabled
                                                        style={{ width: 100 }}
                                                        value={typeof this.state.medicament.cantidad !== 'undefined' ? this.state.medicament.cantidad + this.state.medicament.unidadmedida : ""}
                                                    />  </td>
                                                    <td ><TextField
                                                        type="text"
                                                        className="material-form__field"
                                                        disabled
                                                        style={{ width: 150 }}
                                                        value={typeof this.state.medicament.viaadministracion !== 'undefined' ? this.state.medicament.viaadministracion : ""}
                                                    /> </td>
                                                    <td ><TextField
                                                        required
                                                        type="number"
                                                        className="material-form__field"
                                                        style={{ width: 80 }}
                                                        value={this.state.dosis}
                                                        onChange={(event) => {
                                                            //this.handlerDosis(event.target.value);
                                                            row.dosis = event.target.value;
                                                        }}
                                                    />  </td>
                                                    <td ><TextField
                                                        className="material-form__field"
                                                        style={{ width: 180, marginTop: 12 }}
                                                        select
                                                        onChange={(event) => {
                                                            //this.handlerFrequence(event.target.value);
                                                            row.frecuencia = event.target.value;
                                                        }}
                                                    >
                                                        <MenuItem className="material-form__option" key={0} value={'Una vez al día'}>Una vez al día</MenuItem>
                                                        <MenuItem className="material-form__option" key={1} value={'Dos veces al día'}>Dos veces al día</MenuItem>
                                                        <MenuItem className="material-form__option" key={2} value={'Tres veces al día'}>Tres veces al día</MenuItem>
                                                        <MenuItem className="material-form__option" key={3} value={'Cuatro veces al día'}>Cuatro veces al día</MenuItem>
                                                        <MenuItem className="material-form__option" key={4} value={'Dos veces a la semana'}>Dos veces a la semana</MenuItem>
                                                        <MenuItem className="material-form__option" key={5} value={'Cada mes'}>Cada mes</MenuItem>
                                                        <MenuItem className="material-form__option" key={6} value={'Cada dos meses'}>Cada dos meses</MenuItem>
                                                        <MenuItem className="material-form__option" key={7} value={'Cada seis meses'}>Cada seis meses</MenuItem>
                                                        <MenuItem className="material-form__option" key={8} value={'Dosis unica'}>Dosis unica</MenuItem>
                                                    </TextField> </td>
                                                    <td >  <MuiPickersUtilsProvider utils={MomentUtils} >
                                                        <DatePicker
                                                            format="yyyy/MM/DD"
                                                            animateYearScrolling
                                                            style={{ width: 180 }}
                                                            disabled={ailment.value !== "Si"}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            onChange={(date) => {
                                                                row.fecha_inico = moment(new Date(date)).format('YYYY-MM-DD');
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider></td>
                                                    <td >  <MuiPickersUtilsProvider utils={MomentUtils} >
                                                        <DatePicker
                                                            format="yyyy/MM/DD"
                                                            animateYearScrolling
                                                            style={{ width: 180 }}
                                                            disabled={ailment.value !== "Si"}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            onChange={(date) => {
                                                                row.fecha_fin = moment(new Date(date)).format('YYYY-MM-DD');
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider></td>
                                                    <td ><Button color="primary" onClick={() => {
                                                        row.principioactivo = this.state.medicament.principioactivo;
                                                        row.concentracion = this.state.medicament.cantidad + this.state.medicament.unidadmedida;
                                                        row.viaadministracion = this.state.medicament.viaadministracion;

                                                        if (Object.keys(row).length !== 0 && this.state.medicament.length !== 0) {

                                                            this.setState(prevState => ({
                                                                tableData: [...prevState.tableData, row]
                                                            }));
                                                            //this.props.handlerAlimentTable(this.state.tableData, this.props.sectionIndex);                                   
                                                            this.setState({ showTable: true }, () => {
                                                                this.props.handlerAlimentTable(this.state.tableData, this.props.section, this.props.sectionIndex, index);
                                                            });

                                                        } else {
                                                            alert("No ha ingresado los valores");
                                                        }

                                                    }}>
                                                        <span className="lnr lnr-plus-circle" style={{ margin: 'auto', fontSize: 20 }} />
                                                    </Button></td>
                                                </tr>
                                                {this.state.showTable ?
                                                    this.state.tableData.map((data, num) => {
                                                        return <tr key={num}>
                                                            <td></td>
                                                            <td>{data.principioactivo}</td>
                                                            <td>{data.concentracion}</td>
                                                            <td>{data.viaadministracion}</td>
                                                            <td>{data.dosis}</td>
                                                            <td>{data.frecuencia}</td>
                                                            <td>{data.fecha_inico}</td>
                                                            <td>{data.fecha_fin}</td>
                                                            <td><Button color="primary" onClick={() => {
                                                                this.setState({ showTable: false });
                                                                this.state.tableData.splice(num, 1);
                                                                this.setState({ showTable: true }, () => {
                                                                    this.props.handlerAlimentTable(this.state.tableData, this.props.section, this.props.sectionIndex, index);
                                                                });
                                                            }}>
                                                                <span className="lnr lnr-trash" style={{ margin: 'auto', fontSize: 20 }} />
                                                            </Button>
                                                            </td>
                                                        </tr>
                                                    })
                                                    : null}
                                            </tbody>
                                        </table>
                                        : null}
                                    {(this.props.sectionIndex === 3 || this.props.sectionIndex === 4) && ailment.value === "Si" ?
                                        <table className="table table--bordered" >
                                            <thead>
                                                <tr>
                                                    <td>Buscar </td>
                                                    <td >Codigo </td>
                                                    <td >Nombre </td>
                                                    <td >Fecha Ingreso </td>
                                                    <td >Fecha Salida </td>
                                                    <td >Observación</td>
                                                    <td ></td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><Button
                                                        color="primary"
                                                        style={{ paddingLeft: 10, margin: 'auto', fontSize: 20 }}
                                                        onClick={() => {

                                                            this.setState({ openModal: true });
                                                        }}
                                                    >
                                                        <span className="lnr lnr-magnifier" style={{ fontSize: 20 }} />
                                                    </Button> </td>
                                                    <td ><TextField
                                                        type="text"
                                                        className="material-form__field"
                                                        disabled
                                                        style={{ width: 80 }}
                                                        value={typeof this.state.diagnostic.codigo !== 'undefined' ? this.state.diagnostic.codigo : ""}
                                                    /> </td>
                                                    <td ><TextField
                                                        type="text"
                                                        className="material-form__field"
                                                        disabled
                                                        style={{ width: 350 }}
                                                        value={typeof this.state.diagnostic.nombre !== 'undefined' ? this.state.diagnostic.nombre : ""}
                                                    />  </td>

                                                    <td >  <MuiPickersUtilsProvider utils={MomentUtils} >
                                                        <DatePicker
                                                            format="yyyy/MM/DD"
                                                            animateYearScrolling
                                                            style={{ width: 180 }}
                                                            disabled={ailment.value !== "Si"}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            onChange={(date) => {
                                                                row.fecha_ingreso = moment(new Date(date)).format('YYYY-MM-DD');

                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider></td>
                                                    <td > <MuiPickersUtilsProvider utils={MomentUtils} >
                                                        <DatePicker
                                                            format="yyyy/MM/DD"
                                                            animateYearScrolling
                                                            style={{ width: 180 }}
                                                            disabled={ailment.value !== "Si"}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            onChange={(date) => {
                                                                row.fecha_salida = moment(new Date(date)).format('YYYY-MM-DD');
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider></td>
                                                    <td ><TextField
                                                        type="text"
                                                        className="material-form__field"
                                                        style={{ width: 200 }}
                                                        onChange={(e) => {
                                                            row.observacion = e.target.value;
                                                        }}
                                                    />  </td>
                                                    <td ><Button color="primary" onClick={() => {

                                                        row.codigo = this.state.diagnostic.codigo;
                                                        row.nombre = this.state.diagnostic.nombre;

                                                        if (Object.keys(row).length !== 0 && this.state.diagnostic.length !== 0) {

                                                            this.setState(prevState => ({
                                                                tableData: [...prevState.tableData, row]
                                                            }));
                                                            //this.props.handlerAlimentTable(this.state.tableData, this.props.sectionIndex);                                     
                                                            this.setState({ showTable: true }, () => {
                                                                this.props.handlerAlimentTable(this.state.tableData, this.props.section, this.props.sectionIndex, index);
                                                            });

                                                        } else {
                                                            alert("No ha ingresado los valores");
                                                        }
                                                    }}>
                                                        <span className="lnr lnr-plus-circle" style={{ margin: 'auto', fontSize: 20 }} />
                                                    </Button></td>
                                                </tr>
                                                {this.state.showTable ?
                                                    this.state.tableData.map((data, num) => {
                                                        return <tr key={num}>
                                                            <td></td>
                                                            <td>{data.codigo}</td>
                                                            <td>{data.nombre}</td>
                                                            <td>{data.fecha_ingreso}</td>
                                                            <td>{data.fecha_salida}</td>
                                                            <td>{data.observacion}</td>
                                                            <td><Button color="primary" onClick={() => {
                                                                this.setState({ showTable: false });
                                                                this.state.tableData.splice(num, 1);
                                                                this.setState({ showTable: true }, () => {
                                                                    this.props.handlerAlimentTable(this.state.tableData, this.props.section, this.props.sectionIndex, index);
                                                                });
                                                            }}>
                                                                <span className="lnr lnr-trash" style={{ margin: 'auto', fontSize: 20 }} />
                                                            </Button>
                                                            </td>
                                                        </tr>
                                                    })
                                                    : null}
                                            </tbody>
                                        </table>
                                        : null}
                                </Fragment>)
                            }
                        })}
                        {this.props.sectionIndex === 5 ?
                            <div style={{ display: 'flex', height: 70, marginTop: 20 }}>
                                <div style={{ width: 200, }}>
                                    <span className="form__form-group-label"> Observación</span>
                                </div>
                                <div className="form__form-group-field">
                                    <Field
                                        name="textarea-observation"
                                        component="textarea"
                                        type="text"
                                        style={{ width: '90%' }}
                                        //value={this.props.PhysicalExam.skin_appendages}
                                        onChange={(e) => {

                                            this.props.handlerPlanificacion('observations', e.target.value);
                                        }}
                                    />
                                </div>

                            </div> : null}
                    </div>
                    <div style={{ width: '50%' }}>
                        {this.props.sectionAilment[this.props.section].map((ailment, index) => {
                            if (index % 2 === 1) {
                                return (
                                    <div key={ailment.ailment} style={{ display: 'flex', height: 70 }}>
                                        <div style={{ width: 350 }}>
                                            <span className="form__form-group-label">{ailment.ailment}</span>
                                            <div className="form__form-group-field">
                                                <label
                                                    className="radio-btn"
                                                >
                                                    <input
                                                        className="radio-btn__radio"
                                                        name={ailment.ailment}
                                                        type="radio"
                                                        value={'Si'}
                                                        defaultChecked={ailment.value === "Si"}
                                                        onChange={(e) => {
                                                            this.props.handlerAilment(e.target.value, this.props.section, this.props.sectionIndex, index);
                                                            var showCommentaties = this.state.showCommentaties;
                                                            showCommentaties[index] = true;
                                                            this.setState({ showCommentaties: showCommentaties });
                                                        }}
                                                    />
                                                    <span className="radio-btn__radio-custom" />
                                                    <span className="radio-btn__label">{"Sí"}</span>
                                                </label>
                                                <label
                                                    className="radio-btn"
                                                >
                                                    <input
                                                        className="radio-btn__radio"
                                                        name={ailment.ailment}
                                                        type="radio"
                                                        value={'No'}
                                                        defaultChecked={ailment.value === "No"}
                                                        onChange={(e) => {
                                                            this.props.handlerAilment(e.target.value, this.props.section, this.props.sectionIndex, index);
                                                            var showCommentaties = this.state.showCommentaties;
                                                            showCommentaties[index] = false;
                                                            this.setState({ showCommentaties: showCommentaties });
                                                        }}
                                                    />
                                                    <span className="radio-btn__radio-custom" />
                                                    <span className="radio-btn__label">{"No"}</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="form__form-group" style={{ width: '90%', marginRight: 20, marginTop: 20 }}>
                                            <div className="form__form-group-field">
                                                <input
                                                    key={`comment-${ailment.ailment}`}
                                                    name={`comment-${ailment.ailment}`}

                                                    disabled={ailment.value !== "Si"}
                                                    type="text"
                                                    placeholder="NO REFIERE."
                                                    value={ailment.commentary}
                                                    onChange={(e) => {
                                                        this.props.handlerCommentary(e.target.value, this.props.section, this.props.sectionIndex, index);
                                                        var commentaries = this.state.commentaries;
                                                        commentaries[index] = e.target.value;
                                                        this.setState({ commentaries: commentaries });
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        {this.props.sectionIndex === 0 ?
                                            <div className="form__form-group-field" style={{ marginLeft: 10, }}>
                                                <MuiPickersUtilsProvider utils={MomentUtils} >
                                                    <DatePicker
                                                        label="Fecha "
                                                        format="yyyy/MM/DD"
                                                        animateYearScrolling
                                                        style={{ width: '50%' }}
                                                        disabled={ailment.value !== "Si"}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        onChange={(date) => {
                                                            this.props.handlerAilmentDate(moment(new Date(date)).format("YYYY/MM/DD"), this.props.section, this.props.sectionIndex, index);
                                                            var showDate = this.state.showDate;
                                                            showDate[index] = true;
                                                            this.setState({ showDate: showDate });

                                                        }}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </div>
                                            : null}
                                    </div>)
                            }
                        })}
                        {this.props.sectionIndex === 5 ?
                            <>
                                <div style={{ display: 'flex', height: 70 }}>
                                    <div style={{ width: 200, marginTop: 10 }}>
                                        <span className="form__form-group-label">Metodo de Planificación</span>
                                    </div>
                                    <div className="form__form-group" style={{ width: '90%', marginRight: 20, marginTop: 20 }}>
                                        <div className="form__form-group-field">
                                            <input
                                                key="metodo"
                                                name="metodo-plan"
                                                //component={renderField}
                                                type="text"
                                                placeholder=""
                                                //value={ailment.commentary} 
                                                onChange={(e) => {
                                                    //console.log(e.target.value);
                                                    this.props.handlerPlanificacion('method', e.target.value);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', height: 70, marginTop: 20 }}>
                                    <div style={{ width: 200 }}>
                                        <span className="form__form-group-label"> Otros Metodos</span>
                                    </div>
                                    <div className="form__form-group-field">
                                        <Field
                                            name="textarea-othermet"
                                            component="textarea"
                                            type="text"
                                            style={{ width: '90%' }}
                                            onChange={(e) => {
                                                //console.log(e.target.value)
                                                this.props.handlerPlanificacion('ohter_method', e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>
                            </>
                            : null}
                    </div>
                </div>
                <Modal
                    open={this.state.openMedicaments}
                    onClose={() => {
                        this.setState({ openMedicaments: false });
                    }}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                        <div>
                            <h5 className="bold-text">Medicamentos</h5>
                        </div>
                        <div className="form">
                            <div style={{ display: 'flex', width: '100%' }}>
                                <div className="form__form-group" style={{ marginRight: 10 }}>
                                    <span className="form__form-group-label">Principio Activo</span>
                                    <div className="form__form-group-field">
                                        <Field
                                            name="search-cups"
                                            component="input"
                                            type="text"
                                            placeholder="nombre"
                                            //value={this.props.MedicalOrders.cups.cupsnom}
                                            onChange={(e) => {
                                                //this.props.handlerCUPS(e.target.value);                                               
                                                this.setState({ loadMedicaments: true }, () => {
                                                    this.props.searchMedicaments(e.target.value).then((dataMedicaments) => {
                                                        this.setState({ dataMedicaments: dataMedicaments, loadMedicaments: false })
                                                    })
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                            {!this.state.loadMedicaments ?
                                <DataReactTable
                                    title=""
                                    reactTableData={reactTableMedicaments}
                                    config={{
                                        withPagination: true,
                                        withSearchEngine: false,
                                        isSortable: false,
                                        watchCustomMenu: false
                                    }}
                                    ReactTableActions={ReactTableActionsMedics}
                                    Callback={(medicament) => {
                                        //console.log(medicament);
                                        this.setState({ medicament: medicament, openMedicaments: false });
                                    }}
                                /> : <div style={{ margin: 'auto', width: 280, height: 480 }}>
                                    <div class="load__icon-wrap">
                                        <svg class="load__icon">
                                            <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                                        </svg>
                                    </div>
                                </div>}
                        </div>
                    </div>
                </Modal>
                <Modal
                    open={this.state.openModal}
                    onClose={() => {
                        this.setState({ openModal: false });
                    }}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                        <div>
                            <h5 className="bold-text">Diagnostico</h5>
                        </div>
                        <div className="form">
                            <div style={{ display: 'flex', width: '100%' }}>
                                <div className="form__form-group" style={{ marginRight: 10 }}>
                                    <span className="form__form-group-label">CIE 10</span>
                                    <div className="form__form-group-field">
                                        <Field
                                            name="search-cups"
                                            component="input"
                                            type="text"
                                            placeholder="Codigo"
                                            //value={this.props.MedicalOrders.cups.cupsnom}
                                            onChange={(e) => {
                                                //this.props.handlerCUPS(e.target.value);                                                
                                                this.setState({ load: true }, () => {
                                                    this.props.searchDiagnostic("", e.target.value).then((dataDiagnostic) => {
                                                        this.setState({ dataDiagnostic: dataDiagnostic, load: false });
                                                    });
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="form__form-group">
                                    <span className="form__form-group-label">Nombre</span>
                                    <div className="form__form-group-field">
                                        <input
                                            name="search-diagnostic"
                                            type="text"
                                            placeholder="Diagnostico"
                                            //value={this.props.Diagnostic.name}
                                            onChange={(e) => {
                                                var diagnostic = e.target.value;
                                                this.setState({ load: true }, () => {
                                                    this.props.searchDiagnostic(diagnostic, "").then((dataDiagnostic) => {
                                                        this.setState({ dataDiagnostic: dataDiagnostic, load: false });
                                                    });
                                                });
                                            }}
                                        >
                                        </input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                            {!this.state.load ?
                                <DataReactTable
                                    title=""
                                    reactTableData={reactTableFoundDiagnostics}
                                    config={{
                                        withPagination: true,
                                        withSearchEngine: false,
                                        isSortable: false,
                                        watchCustomMenu: false
                                    }}
                                    ReactTableActions={ReactTableActionsDiagnostic}
                                    Callback={(diagnostic) => {
                                        this.setState({ diagnostic: diagnostic, openModal: false });
                                    }}
                                /> : <div style={{ margin: 'auto', width: 270, height: 420 }}>
                                    <div class="load__icon-wrap">
                                        <svg class="load__icon">
                                            <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                                        </svg>
                                    </div>
                                </div>}
                            {!this.state.load && this.state.dataDiagnostic.length === 0 ?
                                <div style={{ margin: 'auto', width: 270, height: 420 }}>
                                    No hay elementos que mostrar
                                </div>
                                : null}
                        </div>
                    </div>
                </Modal>
            </div>)
    }
}

export default reduxForm({
    form: `back-form`, // a unique identifier for this form
})(withTranslation('common')(SectionAilment));

SectionAilment.propTypes = {
    ailments: PropTypes.array.isRequired,
    section: PropTypes.string
}